import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-ads-control[hasError]',
    templateUrl: './ads-control.component.html',
    styleUrls: ['./ads-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdsControlComponent implements OnInit {

  @Input() hasError = false;
  @Input() type: 'text' | 'checkbox' | 'ain';

  constructor() { }

  ngOnInit(): void {
  }

}
